import React from 'react'

const RoleUpdateIneligibleTemplate = ({ 
  studentName = '[Student Name]',
  roleName = '{Role Name}',
  companyName = '{company name}',
  userName = '{userName}',
  userRole = '{userRole}',

}) => {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
     
      
      <p>Dear {studentName},</p>
     
      <p style={{paddingTop:'8px'}}>
        We wanted to inform you that, based on the updated Job Description of {roleName} at {companyName}, 
        you are no longer eligible for the role you applied for. As a result, you have been removed from the applied students list.
      </p>
     
      <p style={{paddingTop:'8px'}}>
        Please take a moment to review the updated JD. If you believe you meet the new criteria, kindly update your profile and
        reapply for the role.
      </p>
   
      <p style={{paddingTop:'10px',paddingBottom:'2px',margin:'0px'}}>Best regards,</p>
      <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{userName}</p>
      <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{userRole}</p>
    </div>
  )
}

export default RoleUpdateIneligibleTemplate
